import React from "react";
import styles from "./OurPartners.module.css";
import spinnyLogo from "../assets/spinny1.png";
import cars24Logo from "../assets/car24.png";

function OurPartners() {
  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Our Partners</h3>
      <div className={styles.partnerList}>
        <div className={styles.card}>
          <a
            href="https://www.spinny.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={spinnyLogo}
              alt="Spinny"
              style={{
                width: "256px",
                height: "84px",
              }}
            />
          </a>
        </div>
        <div className={styles.card}>
          <a
            href="https://www.cardekho.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={cars24Logo}
              alt="Cars24"
              style={{
                width: "256px",
                height: "84px",
              }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default OurPartners;
